module.exports = __webpack_public_path__ + "img/team_tea.d193be99.jpg";